module.exports = __webpack_public_path__ + "static/media/hypeschools.3bb0d2a9.webp";